import { render } from "./Konncomputop.vue?vue&type=template&id=d9a8ce02"
import script from "./Konncomputop.vue?vue&type=script&lang=js"
export * from "./Konncomputop.vue?vue&type=script&lang=js"

import exportComponent from "/home/cellposition/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__